import {
  Link as MuiLink,
  ListItem,
  ListItemText,
  MenuItem,
  SelectChangeEvent
} from "@mui/material"
import useLanguage from "hooks/useLanguage"
import useUserContext from "hooks/useUserContext"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { languages, ROUTES } from "utils/constants"

import {
  StyledList,
  StyledListItemButton,
  StyledSelect
} from "./NavigationLinks.styles"
import { INavigationLinks, ListLinkType } from "./NavigationLinks.types"

const NavigationLinks: FC<INavigationLinks> = ({
  direction: flexDirection = "column"
}) => {
  const { t } = useTranslation("global")

  const { salesforceAuthenticated } = useUserContext()
  const { language, setLanguage } = useLanguage()

  const handleLanguageChange = (event: SelectChangeEvent<unknown>) => {
    setLanguage(event.target.value as string)
  }

  const linkList = [
    {
      displayName: t("component.Header.support"),
      href: "https://rrts1614707543.atlassian.net/servicedesk/customer/portal/3/group/13/create/55",
      external: true,
      testID: "LinkSupport"
    }
  ] as ListLinkType[]

  if (salesforceAuthenticated) {
    linkList.unshift({
      displayName: t("component.Header.compliance"),
      href: `${process.env.REACT_APP_COMPLIANCE_BASE_URL}/${process.env.REACT_APP_COMPLIANCE_ROUTE}/?auth=${process.env.REACT_APP_COMPLIANCE_AUTH_SUFFIX}`,
      external: true,
      testID: "LinkCompliance"
    })
  }

  return (
    <StyledList direction={flexDirection}>
      <StyledListItemButton component={Link} to={ROUTES.RESOURCES}>
        <ListItemText primary={t("component.NavigationLinks.resources")} />
      </StyledListItemButton>

      {linkList.map(({ displayName, testID, href }, linksIndex) => {
        const linkKey = `link-key-${displayName}-${linksIndex}`

        return (
          <StyledListItemButton
            component={MuiLink}
            data-testid={testID}
            href={href}
            key={linkKey}
            rel="noopener noreferrer"
            target="_blank"
          >
            <ListItemText primary={displayName} />
          </StyledListItemButton>
        )
      })}
      <ListItem>
        <StyledSelect
          fullWidth
          data-testid="language"
          label=""
          size="small"
          value={language}
          variant="outlined"
          onChange={handleLanguageChange}
        >
          {languages.map((languageItem) => {
            return (
              <MenuItem key={languageItem.code} value={languageItem.code}>
                {languageItem.name}
              </MenuItem>
            )
          })}
        </StyledSelect>
      </ListItem>
    </StyledList>
  )
}

export default NavigationLinks
